import app from 'flarum/forum/app';

app.initializers.add('justoverclock/be-active-user-indicator', () => {
  console.log('[justoverclock/be-active-user-indicator] Hello, forum!');
});
